/**
 * Search Page Bundle
 * पेज-специфичная логика + фильтры.
 */

// 1. Modules essential for this page
import '../app/modules/api/search-api.js';

// 2. Filters (Ensuring they are in the same bundle for reliable init)
import '../app/modules/filters/filter-controller.js';
import '../app/modules/filters/filter-manager.js';
import '../app/modules/filters/filters-toggle.js';

// 3. UI Components — ghost autocomplete for #fnd_searchbox.
// Must precede main.js so window.SearchAutocomplete is registered before search-input.js binds.
import '../components/search-autocomplete.js';

// 4. Main Application Entry
import '../app/main.js';
import '../app/cache-buster.js';

console.log('Search Bundle (Integrated Modules) Loaded');
